<template>
     <div class="row">
        <div class="col-md-6">
            <vue-select
                :title="!nolabel ? 'Prezzo Min' : null"
                :labelcolor="labelcolor"
                :primarycolor="primarycolor"
                name="min_price"
                selectname="prezzomin"
                :options="prezzi"
                :taggable="false"
                trackby="id"
                :searchable="false"
                :placeholder="nolabel ? 'Prezzo Min' : 'Seleziona...'"
                :currentvalue="currentValue.minPrice ? currentValue.minPrice : null"
                @onChange="onChange($event, 'minPrice')"
            ></vue-select>
        </div>
        <div class="col-md-6">
            <vue-select
                :title="!nolabel ? 'Prezzo Max' : null"
                :labelcolor="labelcolor"
                :primarycolor="primarycolor"
                name="max_price"
                selectname="prezzomax"
                :options="prezzi"
                :taggable="false"
                :searchable="false"
                trackby="id"
                :placeholder="nolabel ? 'Prezzo Max' : 'Seleziona...'"
                :currentvalue="currentValue.maxPrice ? currentValue.maxPrice : null"
                @onChange="onChange($event, 'maxPrice')"
            ></vue-select>
        </div>
    </div>
</template>

<script>

export default {
    props: [
        'prezzi',
        'nolabel',
        'labelcolor',
        'currentsearch',
        'primarycolor'
    ],
    methods: {
        onChange(value, type) {

            this.currentValue[type] = value.id ? value : null;

            if(value.id) {
                if(value && type === 'minPrice') {
                    if(this.currentValue.maxPrice && value.id > this.currentValue.maxPrice.id) {
                        this.currentValue.minPrice = {...this.currentValue.maxPrice};
                    }
                }
                if(value && type === 'maxPrice') {
                    if(this.currentValue.minPrice && value.id < this.currentValue.minPrice.id ) {
                        this.currentValue.maxPrice = {...this.currentValue.minPrice};
                    }
                }
            }
            this.$emit('onChange', this.currentValue);
        },
        getValue(value) {
            return this.prezzi.find((item) => {
                return Number(value) === item.id;
            });
        }
    },
    mounted() {
        if(this.currentsearch) {
            this.currentValue.minPrice = this.getValue(this.currentsearch.min_price);
            this.currentValue.maxPrice = this.getValue(this.currentsearch.max_price);
        }
    },
    data() {
        return {
            currentValue: {
                minPrice: undefined,
                maxPrice: undefined
            }
        }
    },
    watch: {
        // lasciato il watcher per evitare di dover riscrivere tutto il componente e ridurre la duplicazione del codice
        prezzi () {
            if (this.currentsearch) {
              this.currentValue.minPrice = this.getValue(this.currentsearch.min_price);
              this.currentValue.maxPrice = this.getValue(this.currentsearch.max_price);
            }
        }
    }
}
</script>

<style>

</style>
